import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AuthorizationService } from "./_services/authorization.service";
import { isEmeniBackendUrl } from "./_helpers/isEmeniBackendUrl";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  constructor(private authService: AuthorizationService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // JWT ide SAMO na eMeni backend. Bez ovoga bi se token slao svakom domenu (npr.
    // maps.googleapis.com) — što je i bezbednosni propust i ruši JSONP zahteve
    // ("JSONP requests do not support headers").
    if (req.method === 'JSONP' || !isEmeniBackendUrl(req.url)) {
      return next.handle(req);
    }

    var token = this.authService?.getToken();

    if (token) {
      const cloned = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
      return next.handle(cloned);
    }
    return next.handle(req);
  }
}
